import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=1294e6e1&scoped=true&"
var script = {}
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=1294e6e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294e6e1",
  null
  
)

export default component.exports